import "./DeckRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import DeckHeader from "./sections/DeckHeader";
import DeckGuide from "./sections/DeckGuide";
import DeckFaq from "./sections/DeckFaq";
import RelatedLinksEstimate from "./sections/RelatedLinksEstimate";
import Footer from "@/reusable_sections/Footer";
export default function DeckRemodelingPage() {
  return <div>
      <Header />
      <DeckHeader />
      <DeckGuide />
      <DeckFaq />
      <RelatedLinksEstimate />
      <Footer />
    </div>;
}